export const GAME_CONFIG = {
    // Display
    WIDTH: 1920,
    HEIGHT: 1080,
    BACKGROUND_COLOR: '#0a0a0f',

    // Board
    BOARD_COLS: 6,
    BOARD_ROWS: 5,
    ORB_SIZE: 100,
    ORB_SPACING: 6,

    // 6 Gem types: 5 elements + Shield
    ORB_COLORS: {
        R: 0xe74c3c, // Red - THERMAL
        B: 0x3498db, // Blue - CRYO
        G: 0x2ecc71, // Green - RADIATION
        Y: 0xf1c40f, // Yellow - EMP
        P: 0x9b59b6, // Purple - VOID
        S: 0xecf0f1, // Shield - silver/white
    } as const,

    // Secondary colors for gem depth/shading
    ORB_COLORS_DARK: {
        R: 0xc0392b,
        B: 0x2980b9,
        G: 0x27ae60,
        Y: 0xd4a300,
        P: 0x8e44ad,
        S: 0xbdc3c7,
    } as const,

    ORB_COLORS_LIGHT: {
        R: 0xff6b6b,
        B: 0x74b9ff,
        G: 0x55efc4,
        Y: 0xffeaa7,
        P: 0xd4a4eb,
        S: 0xffffff,
    } as const,

    // Spawn weights (S is rarer, elements equal)
    ORB_SPAWN_WEIGHTS: {
        R: 17,
        B: 17,
        G: 17,
        Y: 17,
        P: 17,
        S: 15,
    } as const,

    // Animation timing (ms) - base values, cascade will speed these up
    ANIMATION: {
        SWAP_DURATION: 100,          // Base swap tween duration
        GRAVITY_DURATION: 140,       // Base fall duration per cell
        MATCH_FADE_DURATION: 120,    // Base match fade-out duration
        CASCADE_SPEED_MULT: 0.75,    // Each cascade multiplies duration by this (faster cascades)
        MIN_SPEED_MULT: 0.35,        // Minimum speed multiplier (don't go faster than this)
        SWAP_OVERSHOOT: 1.1,         // Overshoot factor for swap bounce
        GRAVITY_BOUNCE: 0.15,        // Bounce factor at end of gravity
    } as const,

    // Timing
    MOVE_TIME_SECONDS: 10.0,

    // Shield pity (for S orbs)
    SHIELD_PITY_TURNS: 2,
    SHIELD_PITY_BONUS: 0.08,

    // Combat (fallback - actual value comes from modules.json ship.baseStats.shieldMax)
    BASE_SHIELD: 60,
    SHIELD_PER_ORB: 2, // Multiplier for shield gained per S orb match

    RESIST_CAP: 0.6,

    // Ship fitting
    WEAPON_SLOTS: 2,
    SUPPORT_SLOTS: 3,
    CMP_BUDGET: 40,
    RCT_BUDGET: 40,

    // Run
    MAP_ROWS: 10,
    THREAT_LEVELS: 10,

    // Scoring
    SCORE_PER_NODE: 100,
    SCORE_PER_COMBO: 50,
    SCORE_PER_ELITE: 25,
    SCORE_PER_BOSS: 500,
    SCORE_PER_SCRAP: 1,
} as const;

export type OrbColor = keyof typeof GAME_CONFIG.ORB_COLORS;
